import {api} from './api';
import type {EmailAccount, TaskProgress} from '@/types';

export const syncService = {
  /** Get all linked email accounts. */
  async getEmailAccounts(): Promise<EmailAccount[]> {
    const {data} = await api.get<{results: EmailAccount[]}>('/mail/email-account/');
    return data.results;
  },

  /** Enable email sync for an account. */
  async enableSync(accountId: string): Promise<EmailAccount> {
    const {data} = await api.patch<EmailAccount>(`/mail/email-account/${accountId}/`, {
      enabled_email_sync: true,
    });
    return data;
  },

  /** Disable email sync for an account. */
  async disableSync(accountId: string): Promise<EmailAccount> {
    const {data} = await api.patch<EmailAccount>(`/mail/email-account/${accountId}/`, {
      enabled_email_sync: false,
    });
    return data;
  },

  /** Remove an email account entirely. */
  async removeAccount(accountId: string): Promise<void> {
    await api.delete(`/mail/email-account/${accountId}/`);
  },

  /** Get all background tasks (for sync progress). */
  async getTasks(): Promise<TaskProgress[]> {
    const {data} = await api.get<{task_progress: TaskProgress[]}>('/core/tasks/');
    return data.task_progress;
  },

  /** Get a single task's progress. */
  async getTask(taskId: string): Promise<TaskProgress> {
    const {data} = await api.get<TaskProgress>(`/core/tasks/${taskId}/`);
    return data;
  },
};
